import { render, staticRenderFns } from "./ReservationSchedules.vue?vue&type=template&id=0a6a21c4&scoped=true&lang=pug"
import script from "./ReservationSchedules.vue?vue&type=script&lang=ts"
export * from "./ReservationSchedules.vue?vue&type=script&lang=ts"
import style0 from "./ReservationSchedules.vue?vue&type=style&index=0&id=0a6a21c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a21c4",
  null
  
)

export default component.exports